/**
* Stats JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stats component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'stats',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $.fn.digits = function() {
        return this.each( function() {
          $( this ).text( $( this ).text().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' ) );
        } );
      };

      ScrollTrigger.create( {
        trigger: $( '.stats' ),
        start: 'top 97%',
        scrub: 0.15,
        // markers: true,
        onEnter: ( {progress, direction, isActive} ) => {
          $( '.stats__number' ).each( function() {
            const $this = $( this );
            const countTo = $this.data( 'count' );

            $( {
              countNum: 0,
            } ).animate( {
              countNum: countTo,
            },
            {
              duration: 2000,
              easing: 'linear',
              step: function() {
                $( $this.text( Math.floor( this.countNum ) ) ).digits();
              },
              complete: function() {
                $( $this.text( this.countNum ) ).digits();
              },
            } );
          } );
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stats', COMPONENT );
} )( app );
